import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import ModalPop from '../modal/modal';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const BulkUpload = ({
  handleModalHide = null,
  handlebulkSubmit = null,
  isbulk = null,
  handleFileChange = null,
  isUploaded = null,
  sampleData = null,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  return (
    <Fragment>
      <ModalPop
        title={localization.bulkUpload}
        show={isbulk}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
        footer={!isUploaded && true}
        footerSubmitTxt={localization.submit}
        handleModalSubmit={handlebulkSubmit}
      >
        <div className="bulk_upload text-center">
          {isUploaded && (
            <Fragment>
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <p>{localization.uploadSuccess}</p>
              <Link
                to={`${baseUrl}/preSalesListing`}
                className="btn btn-primary mb-4"
              >
                {localization.preSales} <img src={Images?.ArrowRight} alt="" />
              </Link>
            </Fragment>
          )}
          {!isUploaded && (
            <div style={{ margin: '4px' }}>
              <a
                className="btn btn-primary w-auto ml-2"
                href={sampleData && sampleData.file_url}
                download
              >
                {localization.downloadSample}
              </a>
              <br />
              <br />
              <FileUpload
                isBase64={true}
                id="bulk_upload"
                accept=".xlsx,.xls,.xlsm,.xlsb,.xltx"
                onChange={(val) => {
                  handleFileChange(val);
                }}
              >
                <span className="btn btn-transparent">
                  {localization.bulkUpload}
                </span>
              </FileUpload>
            </div>
          )}
        </div>
      </ModalPop>
    </Fragment>
  );
};

BulkUpload.propTypes = {
  handleModalHide: PropTypes.func,
  handlebulkSubmit: PropTypes.func,
  isbulk: PropTypes.bool,
  handleFileChange: PropTypes.func,
  isUploaded: PropTypes.bool,
};

export default BulkUpload;
